import { render, staticRenderFns } from "./AwardLogin.vue?vue&type=template&id=4aed3a4e&scoped=true&"
import script from "./AwardLogin.vue?vue&type=script&lang=js&"
export * from "./AwardLogin.vue?vue&type=script&lang=js&"
import style0 from "./AwardLogin.vue?vue&type=style&index=0&id=4aed3a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed3a4e",
  null
  
)

export default component.exports